(function ($, document, window) {
    $(document).ready(function () {
        let customSelects = $("select.c-select");
        // console.log(customSelects.length);
        for(let i = 0; i < customSelects.length; i++) {
            generateSelect($(customSelects[i]));
        }

        // customSelectOnClick();
    });

    $("body").on("click", "div[for-select-name] input", function (e) {
        $(this).focus();
        let optionholder = $(this).parent().children("[select-option-holder]");
        // console.log($(this));
        // console.log($(optionholder));
        optionholder.removeClass("d-none");
    })

    $("body").on("focusout", "div[for-select-name] input", function(e) {
        // console.log(e);
        let target = $(e.currentTarget);
        // console.log(target);
        // console.log($(this));
        if (
            $(this).attr("select-option-holder") === undefined &&
            $(this).attr("select-option-holder-absolute") === undefined &&
            $(this).attr("custom-select-option-value") === undefined
        ) {
            let optionholder = $(this).parent().children("[select-option-holder]");
            optionholder.removeClass("d-none")
        }
    })

    $("body").on("click", function (e) {
        if ($(e.target).parents("div[for-select-name]").length > 0) {
            let input = $($(e.target).parents(".c-select-box")).children("[select-search]");
            if (input.attr("select-search") !== undefined) {
                $(input).val("");
                let custom_select = $($(e.target).parents(".c-select-box"));
                // console.log($(custom_select.parent()).children("select"));
                let select = $(custom_select.parent()).children("select")[0];
                $(select).children("option").each(function () {
                    if ($(this).attr("selected") !== undefined) {
                        $(this).removeAttr("selected");
                    }
                })
                $(select).val("");
            }

            if ($(e.target).attr("custom-select-id") !== undefined) {
                let option = $(e.target);
                let select_id = option.attr("custom-select-id");
                // console.log(select_id);
                let select = $($(option.parents(".c-select-box")).parent()).children("select");
                select.children("option").each(function () {
                    $(this).removeAttr("selected");
                })
                let invis_option = $(select).children("[custom-select-id='"+select_id+"']")[0];
                // console.log(select);
                $(invis_option).attr("selected", true);
                // console.log(invis_option);
                let option_name = $(invis_option).html();
                let option_value = $(invis_option).attr("value");
                // console.log(option_value);
                let search_input = $(option.parents(".c-select-box")).children("[select-search]");
                $(search_input).val(option_name);

                let search_result = $(option.parents(".c-select-box")).children("[select-result]");
                search_result.attr("select-result-name", option_name);
                search_result.attr("select-result-value", option_value);

                $("div[for-select-name]").each(function () {
                    $(this).children("[select-option-holder]").addClass("d-none");
                });
            }
            return;
        }

        $("div[for-select-name]").each(function () {
            $(this).children("[select-option-holder]").addClass("d-none");
        });
    });

    $("body").on("keyup", "[select-search]", function (e) {
        console.log("keyup");
        customSelectSearch($(this));
    })
    
    function customSelectSearch(input) {

        let select_box = $(input.parent());
        let value = input.val();
        // console.log(value);
        // console.log(select_box.children("[select-option-holder]").children("[select-option-holder-absolute]").children("[custom-select-option]"));
        select_box
            .children("[select-option-holder]")
            .children("[select-option-holder-absolute]")
            .children("[custom-select-option]")
            .each(function () {
                // console.log($(this).html().includes(value));
                // console.log(value);
                // console.log($(this).html());
                // console.log($(this));
                if ( $(this).html().toLowerCase().includes(value.toLowerCase())) {
                    // console.log("indexOf");
                    $(this).removeClass("d-none");
                    $(this).addClass("d-block");
                }else if(value === "") {
                    // console.log("Val==''")
                    $(this).removeClass("d-none");
                    $(this).addClass("d-block");
                }else {
                    // console.log("NoMatch");
                    $(this).addClass("d-none");
                    $(this).removeClass("d-block");
                }
            });

        let parent = $(input.parents(".c-select-box")).parent();

    }

    function generateSelect(select) {
        let options = select.children("option");
        // console.log(select);
        select.after(
            "<div for-select-name='"+select.attr("name")+"' class='c-select-box'>" +
                "<input type='hidden' class='d-none text-white col-12 px-0' select-result-value='' select-result-name='' select-result/>" +
                "<input class='form-control mb-0 text-white' type='text' select-search />" +
                "<div class='position-relative d-none' select-option-holder>" +
                    "<div class='position-absolute bg-white col-12 p-0' select-option-holder-absolute></div>" +
                "</div>" +
            "</div>"
        );

        select.addClass("d-none");
        let customselect = $("div[for-select-name='"+select.attr("name")+"']");
        let optionholder = customselect.children("div[select-option-holder]");
        for(let i = 0; i < options.length; i++) {
            $(options[i]).attr("custom-select-id", i);
            let option_name = $(options[i]).html();
            let option_value = $(options[i]).val();
            $(optionholder.children()[0]).append(
                "<span class='col-12 text-dark d-block py-2 px-2' custom-select-id='"+i+"' custom-select-option-value='"+option_value+"' custom-select-option>" +
                    option_name +
                "</span>"
            )
        }
    }
}(jQuery, document, window))